import React, { useState, useRef } from "react";
import { FaPlay } from "react-icons/fa6";
import { BsFillPauseFill } from "react-icons/bs";
import VideoSrc from "../../Assets/videos/house_land.mp4";
import { getalllandcmsdata } from "../../Hooks/useUserHook";
import { useEffect } from "react";
import { API_URL } from "../../config/env";
function VideoSec() {
  const [isPlaying, setIsPlaying] = useState(false);
  const videoRef = useRef(null);

  const [cmsdata, setCmsData] = useState([]);

  useEffect(() => {
    async function fetchdata() {
      const res = await getalllandcmsdata();
      console.log("res cmsdata", res);
      if (res?.data?.type == "success") {
        setCmsData(res?.data?.data);
      }
    }
    fetchdata();
  }, []);

  const cmsFilter = (data) => {
    try {
      let filterdata = cmsdata?.find(
        (el) => el.Identifier == data && el?.status == "active"
      );
      console.log("filterdata_filterdata", filterdata, filterdata?.updatedAt);
      return filterdata;
    } catch (e) {
      console.log("cmsFilter_err", e);
    }
  };

  // const VideoSrc =
  //   "https://player.vimeo.com/progressive_redirect/playback/682048671/rendition/360p?loc=external&oauth2_token_id=57447761&signature=5be12c7ba41b540b1bb6e8ff3cb8f859e9381ece088946bb8257fe3da7201f79";

  const togglePlayPause = () => {
    if (videoRef.current.paused) {
      // console.log("vde pas");
      setTimeout(() => {
        document.getElementById("play_pause_btn").style.opacity = 0;
      }, 1000);
      videoRef.current.play();
      setIsPlaying(true);
    } else {
      // console.log("vde play")
      document.getElementById("play_pause_btn").style.opacity = 1;

      videoRef.current.pause();
      setIsPlaying(false);
    }
  };

  return (
    <div className="custom_video_sec my-3 my-md-5">
      <div className="container container_custom">
        <div className="header_sec">
          <h3 className="mb-2 mb-md-3 mb-lg-4">
            At home <span className="org_txt">everywhere.</span>
            {/* <span className="org_txt">{cmsFilter("land_banner03")?.Title}</span> */}
          </h3>
          {/* <p>
            From flexible length stays and no security deposits to affordable
            rates in prime neighborhoods, our properties go through a strict
            in-person vetting process to ensure that the quality standards,
            amenities, and accuracy of property description meet and exceed our
            requirements.
          </p> */}
          <p>{cmsFilter("land_banner03")?.Content}</p>
        </div>
        <div className="position-relative videsec_rela mt-3 mt-md-5">
          {cmsFilter("land_banner04") && cmsFilter("land_banner04")?.Video && (
            <video
              ref={videoRef}
              src={`${API_URL}adminImages/cmsvideo/${
                cmsFilter("land_banner04")?.Video
              }`}
              // src={`${API_URL}adminImages/cmsvideo/${cmsFilter("land_banner04")?.Video}`}
              // controls
              width="100%"
            />
          )}
          <div className="position-absolute video-bg-btn">
            <button onClick={togglePlayPause} id="play_pause_btn">
              {isPlaying ? (
                <BsFillPauseFill className="text-white pause-icon" />
              ) : (
                <FaPlay className="play-icon" />
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
export default VideoSec;
